import { api } from "lib/graphql/api"
import { mutate } from "lib/graphql/mutate"
import { gql } from "@apollo/client"

export const deleteAssetRegister = api(async function deleteAssetRegister(id) {
    return mutate(
        gql`
            mutation DeleteAssetRegister($id: String!) {
                deleteAssetRegister(id: $id)
            }
        `,
        { id },
        { returns: "deleteAssetRegister" }
    )
})
